import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import {
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import logo from "../assets/img/logo.jpg";
import { FaAngleDown } from "react-icons/fa";

function Navbar() {
  const [showMega, setShowMega] = useState(false);
  const closeMega = () => setShowMega(false);

  // Media State
  const [showMedia, setShowMedia] = useState(false);

  return (
    <header className="nav-bar">
      <div className="">
        <nav
          className="navbar navbar-expand-lg navbar-light bg-white py-2 px-4"
          style={{
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 2px 8px",
            zIndex: 9999,
            justifyContent: "space-between",
          }}
        >
          {/* Logo */}
          <Link to="/" className="navbar-brand d-flex align-items-center">
            <img
              src={logo}
              alt="Videlicet Law"
              width="100"
              height="60"
              className="me-2"
            />
          </Link>

          {/* Mobile Toggle */}
          <button
            type="button"
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Collapse Wrapper */}
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarCollapse"
          >
            <ul className="navbar-nav align-items-center">
              <li className="nav-item">
                <NavLink
                  to="/home"
                  className={({ isActive }) =>
                    "nav-link" + (isActive ? " active" : "")
                  }
                >
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/about"
                  className={({ isActive }) =>
                    "nav-link" + (isActive ? " active" : "")
                  }
                >
                  About
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/ourteam"
                  className={({ isActive }) =>
                    "nav-link" + (isActive ? " active" : "")
                  }
                >
                  Our Team
                </NavLink>
              </li>
{/* partice area  */}
              <li className="nav-item position-relative">
                <div
                  className="mega-hover-wrapper"
                  onMouseEnter={() => setShowMega(true)}
                  onMouseLeave={() => setShowMega(false)}
                >
                  <NavLink
                    to="/team"
                    className={({ isActive }) =>
                      "nav-link d-flex align-items-center gap-1" +
                      (isActive ? " active text-warning fw-bold" : "text-white")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setShowMega((prev) => !prev);
                    }}
                  >
                    Practice Areas
                    <FaAngleDown
                      className={`mega-toggle-icon ${showMega ? "rotate" : ""}`}
                    />
                  </NavLink>

                  {showMega && (
                    <div
                      className="position-absolute bg-white rounded shadow py-3 px-4"
                      style={{
                        top: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        minWidth: "280px",
                        zIndex: 9999,
                      }}
                    >
                      <ul className="list-unstyled m-0 p-0 text-center">

                        {/* Real Estate */}
                        <li className="mb-2">
                          <NavLink
                            to="/submenu"
                            className={({ isActive }) =>
                              `submenu-dark d-block py-2 px-3 rounded text-decoration-none ${isActive ? "active-dark" : ""
                              }`
                            }
                            onClick={closeMega}
                          >
                            Real Estate
                          </NavLink>
                        </li>

                        {/* Redevelopment */}
                        <li className="mb-2">
                          <NavLink
                            to="/redevelopment"
                            className={({ isActive }) =>
                              `submenu-dark d-block py-2 px-3 rounded text-decoration-none ${isActive ? "active-dark" : ""
                              }`
                            }
                            onClick={closeMega}
                          >
                            Redevelopment
                          </NavLink>
                        </li>

                        {/* Consultancy */}
                        {/* <li className="mb-2">
                          <NavLink
                            to="/consultancy"
                            className={({ isActive }) =>
                              `submenu-dark d-block py-2 px-3 rounded text-decoration-none ${isActive ? "active-dark" : ""
                              }`
                            }
                            onClick={closeMega}
                          >
                            Consultancy
                          </NavLink>
                        </li> */}

                        {/* Legal Support */}
                        {/* <li>
                          <NavLink
                            to="/legal-support"
                            className={({ isActive }) =>
                              `submenu-dark d-block py-2 px-3 rounded text-decoration-none ${isActive ? "active-dark" : ""
                              }`
                            }
                            onClick={closeMega}
                          >
                            Legal Support
                          </NavLink>
                        </li> */}

                      </ul>
                    </div>
                  )}
                </div>
              </li>

              {/* Media */}
              <li className="nav-item position-relative">
                <div
                  className="mega-hover-wrapper"
                  onMouseEnter={() => setShowMedia(true)}
                  onMouseLeave={() => setShowMedia(false)}
                >
                  <NavLink
                    to="/media"
                    className={({ isActive }) =>
                      "nav-link d-flex align-items-center gap-1" +
                      (isActive ? " active text-primary fw-bold" : "text-dark")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setShowMedia((prev) => !prev);
                    }}
                  >
                    Media
                    <FaAngleDown
                      className={`mega-toggle-icon ${showMedia ? "rotate" : ""}`}
                    />
                  </NavLink>

                  {showMedia && (
                    <div
                      className="position-absolute bg-white rounded shadow py-3 px-4"
                      style={{
                        top: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        minWidth: "220px",
                        zIndex: 9999,
                      }}
                    >
                      <ul className="list-unstyled m-0 p-0 text-center">

                        {/* Articles */}
                        <li className="mb-2">
                          <NavLink
                            to="/publications"
                            className={({ isActive }) =>
                              `submenu-item d-block py-2 px-3 rounded text-decoration-none ${isActive ? "active-submenu" : ""
                              }`
                            }
                            onClick={() => setShowMedia(false)}
                          >
                            Articles
                          </NavLink>
                        </li>

                        {/* Videos */}
                        <li className="mb-2">
                          <NavLink
                            to="/video"
                            className={({ isActive }) =>
                              `submenu-item d-block py-2 px-3 rounded text-decoration-none ${isActive ? "active-submenu" : ""
                              }`
                            }
                            onClick={() => setShowMedia(false)}
                          >
                            Videos
                          </NavLink>
                        </li>

                        {/* Photo Gallery */}
                        {/* <li>
                          <NavLink
                            to="/photo-gallery"
                            className={({ isActive }) =>
                              `submenu-item d-block py-2 px-3 rounded text-decoration-none ${isActive ? "active-submenu" : ""
                              }`
                            }
                            onClick={() => setShowMedia(false)}
                          >
                            Photo Gallery
                          </NavLink>
                        </li> */}

                      </ul>
                    </div>
                  )}
                </div>
              </li>
              {/* <li className="nav-item">
                <NavLink
                  to="/video"
                  className={({ isActive }) =>
                    "nav-link" + (isActive ? " active" : "")
                  }
                >
                  Videos
                </NavLink>
              </li> */}

              <li className="nav-item">
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    "nav-link" + (isActive ? " active" : "")
                  }
                >
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
